import * as types from 'models/actionTypes'

export const trackShowDetails = (trackingInfo) => ({
    type: types.TRACK_SHOW_DETAILS,
    trackingInfo,
})

export default trackShowDetails
